// Basic
import PropTypes from 'prop-types';
// Components
import DetailsGrid from '@/common-utils/components/renders/detailsGrid/DetailsGrid';
// Common
import plansFields from '../../fields/plansFields';
import { flattenFieldsObjects } from '@/common-utils/functions/flattenFieldsObjects';
// Style
import './Panels.scss';

/**
 * @param {Object} root
 * @param {Object} root.plan
 * @returns {JSX} DetailsPanel
 */
function DetailsPanel({ plan }) {

    // Constants
    const detailsKeys = ['PRODUCT_CODE', 'LABEL', 'PARENT_SUBSCRIPTION_PLAN.LABEL', 'CREATED_AT', 'UPDATED_AT', 'SHOULD_AUTO_ACTIVATE_SUBSCRIPTIONS'];
    const planDetailsFields = flattenFieldsObjects(detailsKeys, plansFields);

    return (
        <DetailsGrid
            data={plan}
            fields={planDetailsFields}
        />
    );
}

DetailsPanel.propTypes = {
    plan: PropTypes.object.isRequired
};

export default DetailsPanel;